// removed by extract-text-webpack-plugin
module.exports = {"navigation":"src-components-navigation----style-module---navigation---2O6Je","navigation__item":"src-components-navigation----style-module---navigation__item---2S1nh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/style.module.scss
// module id = 317
// module chunks = 35783957827783